import script from "./GateSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./GateSidebar.vue?vue&type=script&setup=true&lang=js"

import "./GateSidebar.vue?vue&type=style&index=0&id=2c8aac20&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c8aac20"]])

export default __exports__